<template>
    <div>
        <page-title heading="Daftar PIC Faskes" :breadcrumb="[
            {
                label: 'Daftar PIC Faskes',
                link: '/pic-klinik'
            },
            {
                label: 'List PIC Faskes',
                active: true
            }
        ]" />
        <div class="container-fluid __zoom_display">
            <div class="ml-4 mb-3">
                <b-button
                    variant="outline-dark"
                    class="align-self-end font-weight-bold mr-2"
                    :to="{
                        name: 'klinik-list'
                    }"
                    style="border-radius:0.65rem"
                >
                    Klinik
                </b-button>
                <b-button
                    variant="outline-primary"
                    class="align-self-end font-weight-bold"
                    :to="{
                        name: 'pic-klinik-list'
                    }"
                    style="border-radius:0.65rem"
                >
                    PIC Faskes
                </b-button>
            </div>
            <div class="card card-box mb-3 ninja-shadow">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-9">
                            <p class="font-weight-bold m-0">Filter by Klinik</p>
                            <p class="m-0">{{ klinikList.length }} klinik dicovered</p>
                            <b-button
                                :variant="variantAll"
                                v-model="selectedFilter"
                                @click="selectedFilter = 'all'"
                                class="align-self-end mr-3 mt-3"
                                style="border-radius:2rem"
                            >
                                Semua Klinik ({{ totalPIC }})
                            </b-button>
                            <span
                                v-for="(item, index) in klinikList"
                                :key="index"
                            >
                                <b-button
                                    :variant="item.variant"
                                    v-model="selectedFilter"
                                    @click="selectedFilter = item.id"
                                    class="align-self-end mr-3 mt-3"
                                    style="border-radius:2rem"
                                    v-if="showAllFilter && index < 2"
                                >
                                    {{ item.nama_klinik }} ({{ item.total_pic }})
                                </b-button>
                                <b-button
                                    :variant="item.variant"
                                    v-model="selectedFilter"
                                    @click="selectedFilter = item.id"
                                    class="align-self-end mr-3 mt-3"
                                    style="border-radius:2rem"
                                    v-else-if="!showAllFilter"
                                >
                                    {{ item.nama_klinik }} ({{ item.total_pic }})
                                </b-button>
                            </span>
                            <b-button
                                variant="link"
                                @click="showAllFilter = false"
                                v-if="showAllFilter && klinikList.length > 2"
                            >
                                <u>Show all</u>
                            </b-button>
                            <b-button
                                variant="link"
                                @click="showAllFilter = true"
                                v-else-if="!showAllFilter"
                            >
                                <u>hide</u>
                            </b-button>
                        </div>
                        <div class="col-md-3">
                            <b-button
                                variant="primary"
                                class="text-capitalize align-self-end float-right"
                                :to="{
                                    name: 'pic-klinik-tambah'
                                }">
                                tambah data PIC
                            </b-button>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="media">
                            <div class="media-left align-self-center">
                                <b-form-checkbox v-model="checkboxAll"></b-form-checkbox>
                            </div>
                            <div class="media-content align-self-center">
                                <b-dropdown size="sm" variant="outline-dark">
                                    <b-dropdown-item @click="checkboxAll = true">
                                        All
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="checkboxAll = false">
                                        None
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                            <div class="media-right align-self-center ml-5">
                                <b-button @click="
                                    resendActivation({
                                        klinik_id: getKlinikId,
                                        pic_id: 'all'
                                    })
                                "
                                    v-if="checkboxAll"
                                    variant="outline-primary"
                                    style="border-radius:0.4rem"
                                >
                                 Kirim Email Aktivasi
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 no-padding">
                        <DataTableWrapper
                            :rows="rows"
                            :perPage="perPage"
                            :fromPage="fromPage"
                            :toPage="toPage"
                            :totalEntries="totalEntries"
                            :currentPage="currentPage"
                            :callbackFunc="fetchListKlinik"
                            @valueChanged="handleValueChanged"
                        >
                            <b-table
                                :items="PICKlinikList"
                                :fields="fieldList"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                thead-tr-class="izd-datatable"
                                :no-local-sorting="true"
                            >
                                <template v-slot:head()="data">
                                    {{ data.label }}
                                    <b-input
                                        size="sm" class="mt-2 w-95"
                                        v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)"
                                    />
                                </template>
                                <template v-slot:head(status)="data">
                                    {{ data.label }}
                                    <template>
                                        <vue-select
                                            :options="optStatus"
                                            v-model="selectedStatus"
                                            class="custom-v-select mt-2"
                                            style="width:100%;background-color:#ffffff;"
                                        >
                                            <template slot="option" slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                        </vue-select>
                                    </template>
                                </template>

                                <template v-slot:cell(no)="data">
                                    <b-form-checkbox
                                        :name="data.item.email"
                                        v-model="checkboxPIC"
                                        :value="data.item.id"
                                        class="text-center"
                                    ></b-form-checkbox>
                                </template>
                                <template v-slot:cell(nama_klinik)="data">
                                    <!-- <template v-if="data.item.klinik_pusat">
                                        {{ data.item.nama_klinik }}
                                        <font-awesome-icon icon="star" style="color:#3c44b1"/>
                                    </template> -->
                                    {{ data.item.nama_klinik }}
                                </template>
                                <template v-slot:cell(kota)="data">
                                   {{ data.item.kota.nama }}
                               </template>
                                <template v-slot:cell(status)="data">
                                    <template v-if="data.item.status == '1'">
                                        <div class="text-center status_waiting">Menunggu Aktivasi</div>
                                    </template>
                                    <template v-else-if="data.item.status == '2'">
                                        <div class="text-center status_active">Aktif</div>
                                    </template>
                                    <template v-else-if="data.item.status == '3'">
                                        <div class="text-center status_deactive">Non-Aktif</div>
                                    </template>
                               </template>
                                <template v-slot:cell(actions)="data">
                                    <span>
                                        <b-dropdown
                                            id="dropdown-1"
                                            class="m-md-2 text-capitalize"
                                            variant="primary"
                                            size="sm"
                                            right
                                        >
                                            <template v-slot:button-content>
                                                <font-awesome-icon icon="copy"/>
                                            </template>
                                            <b-dropdown-item @click="
                                                resendActivation({
                                                    klinik_id: getKlinikId,
                                                    pic_id: data.item.id
                                                })
                                            "
                                                v-if="data.item.status == '1'"
                                            >
                                                Kirim ulang email aktivasi
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="
                                                editKlinik({
                                                    id: data.item.id,
                                                    klinik_id: data.item.klinik.id
                                                })
                                            ">
                                                Edit Data PIC
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="
                                                removeKlinik({
                                                    id: data.item.id,
                                                    klinik_id: data.item.klinik.id
                                                })
                                            ">
                                                Hapus Data PIC
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </span>
                                </template>
                                <template v-slot:cell(last_modified)="data">
                                   <label style="font-size:12px;">
                                        {{ data.item.updated.at }} <br>
                                        by <b>{{ data.item.updated.by }}</b>
                                   </label>
                               </template>
                            </b-table>
                        </DataTableWrapper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import debounce from "lodash/debounce";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCopy,
    faStar
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale('id');
import "vue-datetime/dist/vue-datetime.css";
import {mapGetters} from "vuex";
library.add(faCopy, faStar);

export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper"),
        "vue-select": () => import("vue-select"),
    },
    data() {
        return {
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            PICKlinikList: [],
            searchValue: [],
            totalEntries: 0,
            checkboxPIC: [],
            isCheckedAll: false,
            checkboxAll: false,
            klinikList: [],
            totalPIC: 0,
            showAllFilter: true,
            variantAll: 'outline-primary',
            selectedFilter: 'all',
            users: [],
            optStatus: [
                {
                    key: 1,
                    label: 'Menunggu Aktivasi'
                },
                {
                    key: 2,
                    label: 'Aktif'
                },
                {
                    key: 3,
                    label: 'Non-Aktif'
                }
            ],
            selectedStatus: null,
        };
    },
    watch: {
        currentPage() {
            this.fetchListKlinik();
        },
        perPage() {
            this.fetchListKlinik();
        },
        sortBy() {
            this.fetchListKlinik();
        },
        sortDesc() {
            this.fetchListKlinik();
        },
        searchValue: {
            handler: "fetchListKlinik",
            deep: true
        },
        checkboxAll() {
            if(this.checkboxAll) this.allChecked()
            else this.checkboxPIC = this.users = []
        },
        selectedFilter() {
            this.fetchListKlinik();
            if(this.selectedFilter == 'all') this.variantAll = 'outline-primary'
            else this.variantAll = 'outline-dark'
        },
        selectedStatus() {
            this.fetchListKlinik();
        }
    },
    computed: {
      ...mapGetters(["getKlinikId"]),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(no|actions|checklist|last_modified|status)\b/gi.test(val) ? !1 : 1);
            const fields = [
                { key: "no", label: "" },
                { key: "nama_pic", label: "Nama PIC", thStyle: 'min-width:110px;' },
                { key: "email", label: "Email", thStyle: 'min-width:175px;' },
                { key: "telephone", label: "No. Handphone", thStyle: 'min-width:160px;' },
                { key: "nama_klinik", label: "Nama Klinik", thStyle: 'min-width:140px;' },
                { key: "kota", label: "Kabupaten/Kota"},
                { key: "status", label: "Status", thStyle: 'min-width:185px;', sortable: false },
                { key: "actions" },
                { key: "last_modified", thStyle: 'min-width:155px;' }
            ];

            return (
                fields
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    methods: {
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function(val, key) {
            const { searchValue } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        allChecked() {
            let checked = []
            this.PICKlinikList.forEach(x => {
                checked.push(x.id)
                this.users.push({user_id: x.id})
            })
            this.checkboxPIC = [...new Set(checked)]
        },
        removeKlinik({ id, klinik_id } = {}) {
            this.$swal({
                html: `Menghapus pengguna akan menyebabkan terhapusnya seluruh role yang dimiliki oleh pengguna tersebut. Anda yakin untuk menghapus pengguna ini? <br><br> Untuk menghapus salah satu role milik pengguna, gunakan menu 'Role Management'.`,
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d91632",
                confirmButtonColor: "#3c44b1",
                cancelButtonText: "TIDAK",
                confirmButtonText: "YA, HAPUS"
            }).then(async res => {
                if (res.value) {
                    await this.deleteKlinik(id, klinik_id);
                }
            });
        },
        resendActivation({ klinik_id, pic_id } = {}) {
            this.$swal({
                text: `Anda yakin ingin mengirimkan email aktivasi kepada PIC` + (pic_id == 'all' ? ' yang berstatus menunggu aktivasi?' : ' ini?'),
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d91632",
                confirmButtonColor: "#3c44b1",
                cancelButtonText: "TIDAK",
                confirmButtonText: "YA"
            }).then(async res => {
                if (res.value) {
                    await this.sendEmail(klinik_id, pic_id);
                }
            });
        },
        editKlinik({ id, klinik_id } = {}) {
            if (id && klinik_id) {
                this.$router.push({
                    name: "pic-klinik-edit",
                    params: {
                        user_id: id,
                        klinik_id: klinik_id
                    }
                });
            }
        },
        async deleteKlinik(id, klinik_id) {
            try {
                const res = await axios.delete(
                    `${this.url_api}/klinik/pic/${id}?klinik_id=${klinik_id}`
                );
                const { status, data } = res.data;
                if (status) {
                    this.$swal({
                        type: "success",
                        text: "Data PIC berhasil dihapus"
                    })
                    this.fetchListKlinik()
                } else {
                    this.failedSwal("Data PIC gagal dihapus")
                }
            } catch (err) {
                this.failedSwal("Data PIC gagal dihapus")
            }
        },
        async sendEmail(klinik_id, pic_id) {
            try {
                let res
                if(pic_id == 'all') {
                    res = await axios.post(
                    `${this.url_api}/klinik/pic/resend_email_activation`, {
                        klinik_id: klinik_id,
                        users: this.users
                    });
                } else {
                    res = await axios.post(
                    `${this.url_api}/klinik/pic/resend_email_activation`, {
                        klinik_id: klinik_id,
                         users: [{
                            "user_id" : pic_id
                            }]
                    });
                }
                const { status, data } = res.data;

                if (status) {
                    this.$swal({
                        type: "success",
                        text: "Email aktivasi berhasil dikirim!"
                    })
                    this.fetchListKlinik()
                } else {
                    this.failedSwal("Email aktivasi gagal dikirim!")
                }
            } catch (err) {
                this.failedSwal("Email aktivasi gagal dikirim!")
            }
        },
        failedSwal(text) {
            this.$swal({
                type: "error",
                text: text
            });
        },
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";
            if (this.selectedFilter != 'all') {
                v += `&branch_id=${this.selectedFilter}`
            }

            if(this.selectedStatus != null) {
                v += `&status=${this.selectedStatus.key}`
            }

            searchValue.map(item => {
                const x = item.key;

                if(x == 'telephone') {
                    v += `&phone=${item.value}`;
                } else {
                    v += `&${x}=${item.value}`;
                }
            });

            if (sortBy) {
                if(sortBy == 'status')
                    v += `&column=is_active&order=${sortDesc ? "desc" : "asc"}`;
                else
                    v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }

            return v;
        },
        async fetchListKlinik() {
            try {
                const res = await axios.get(
                    `${this.url_api}/klinik/pic?klinik_id=${this.getKlinikId}&limit=${this.perPage}&page=${this.currentPage}${this.determineParameter()}`
                );
                const { status, data } = res.data;
                this.filterKlinik()

                if (status) {
                    const {
                        data: listPICKlinik,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;

                    this.totalEntries = totalEntries;
                    this.toPage = toPage;
                    this.fromPage = fromPage;                    
                    this.rows = totalEntries

                    // let pusat = null, list = []
                    // listPICKlinik.map(item => {
                    //     if(item.klinik_pusat) pusat = item
                    //     else list.push(item)
                    // })
                    // list.splice(0, 0, pusat)

                    this.PICKlinikList = [
                        ...listPICKlinik.map((item, index) => {
                            return {
                                ...item,
                                no: item.id,
                                nama_klinik: item.klinik.nama,
                                updated: {
                                    at: moment(item.updated.at).format('MMM DD, YYYY @ HH:mm'),
                                    by: item.updated.by || 'anonim'
                                }
                            };
                        })                            
                    ]
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
        async filterKlinik() {
            const res = await axios.get(
                `${this.url_api}/klinik/dropdown?klinik_id=${this.getKlinikId}`
            );
            const { status, data } = res.data;

            if (status) {
                let total = 0
                this.klinikList = [
                        ...data.map((item) => {
                            total += item.total_pic
                            return {
                                ...item,
                                variant: this.selectedFilter == item.id ? 'outline-primary' : 'outline-dark'
                            };
                        })                            
                    ]
                this.totalPIC = total
            } else {
                this.klinikList = []
            }

        }
    }
};
</script>

<style scoped lang="css">
    .bg-kuning {
        background: #f7fc6b;
    }

    .bg-kuning,
    .bg-danger,
    .bg-first {
        color: black !important;
    }

    .no-padding {
        padding: 0 !important;
    }

    .page-item.active a {
        background: #3b86ff;
        border: none !important;
    }

    .ninja-shadow {
        box-shadow: 0px 8px 15px 0px lightgrey;
    }

    .status_active {
        width: 100%;
        border-radius: 8px;
        font-size: 12px;;
        font-weight: bold;
        padding: 7px;
        color: #67cc6f;
        background-color: #c3fad6;
    }

    .status_deactive {
        width: 100%;
        border-radius: 8px;
        font-size: 12px;;
        font-weight: bold;
        padding: 7px;
        color: #f57380;
        background-color: #f8cccf;
    }

    .status_waiting {
        width: 100%;
        border-radius: 8px;
        font-size: 12px;;
        font-weight: bold;
        padding: 7px;
        color: #a7a5ef;
        background-color: #f3f7fb;
    }

    .__zoom_display {
        zoom: 80%;
    }
</style>